import { SidebarWrapper } from './SidebarWrapper';

export default SidebarWrapper;
